/**
 * İzgi Kuyumculuk
 * 15.000 TL üzeri Harf Bileklik otomatik hediye sistemi
 *
 * Kampanya başlangıcı: 1 Temmuz 2026 00.00
 * Kampanya bitişi:     29 Temmuz 2026 00.00
 */
(() => {
  "use strict";

  if (window.__izgiAutoGiftInitialized) return;
  window.__izgiAutoGiftInitialized = true;

  const CONFIG = {
    threshold: 1500000, // 15.000 TL - kuruş cinsinden

    giftHandle: "harf-bileklik-2",
    giftPropertyKey: "_izgi_auto_gift",
    giftPropertyValue: "harf-bileklik-15000",

    cartSectionId: "cart-drawer",

    // Türkiye saatiyle kampanya tarihleri
    campaignStart: "2026-07-01T00:00:00+03:00",
    campaignEnd: "2026-07-29T00:00:00+03:00"
  };

  const nativeFetch = window.fetch.bind(window);

  let syncInProgress = false;
  let syncTimer = null;

  function getCampaignStatus() {
    const now = Date.now();
    const start = new Date(CONFIG.campaignStart).getTime();
    const end = new Date(CONFIG.campaignEnd).getTime();

    if (now < start) return "not-started";
    if (now >= end) return "ended";

    return "active";
  }

  function isCampaignActive() {
    return getCampaignStatus() === "active";
  }

  async function requestJson(url, options = {}) {
    const response = await nativeFetch(url, options);

    if (!response.ok) {
      throw new Error(`İstek başarısız oldu: ${response.status}`);
    }

    return response.json();
  }

  function getCart() {
    return requestJson("/cart.js");
  }

  function isAutoGift(item) {
    return (
      item.properties &&
      item.properties[CONFIG.giftPropertyKey] ===
        CONFIG.giftPropertyValue
    );
  }

  function getQualifyingTotal(cart) {
    return cart.items
      .filter((item) => !isAutoGift(item))
      .reduce((total, item) => {
        return total + Number(item.final_line_price || 0);
      }, 0);
  }

  function getAutoGiftItems(cart) {
    return cart.items
      .map((item, index) => ({
        item,
        line: index + 1
      }))
      .filter(({ item }) => isAutoGift(item));
  }

  async function getGiftVariantId() {
    const product = await requestJson(
      `/products/${CONFIG.giftHandle}.js`
    );

    const variant = product.variants.find(
      (item) => item.available
    );

    if (!variant) {
      throw new Error(
        "Hediye ürünü için aktif varyant bulunamadı."
      );
    }

    return variant.id;
  }

  function refreshCartDrawer(sectionHtml) {
    if (sectionHtml) {
      const parsedDocument = new DOMParser().parseFromString(
        sectionHtml,
        "text/html"
      );

      const newDrawer = parsedDocument.querySelector(
        "cart-drawer#cart-drawer"
      );

      const currentDrawer = document.querySelector(
        "cart-drawer#cart-drawer"
      );

      if (newDrawer && currentDrawer) {
        const currentItems = currentDrawer.querySelector(
          ".cart-drawer__items"
        );

        const newItems = newDrawer.querySelector(
          ".cart-drawer__items"
        );

        const currentFooter = currentDrawer.querySelector(
          '[slot="footer"]'
        );

        const newFooter = newDrawer.querySelector(
          '[slot="footer"]'
        );

        if (currentItems && newItems) {
          currentItems.replaceWith(newItems);
        }

        if (currentFooter && newFooter) {
          currentFooter.replaceWith(newFooter);
        }
      }
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true
      })
    );
  }

  async function cartRequest(endpoint, payload) {
    const response = await requestJson(endpoint, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...payload,
        sections: [CONFIG.cartSectionId],
        sections_url: window.location.pathname
      })
    });

    refreshCartDrawer(
      response.sections?.[CONFIG.cartSectionId]
    );

    return response;
  }

  async function addGift() {
    const variantId = await getGiftVariantId();

    await cartRequest("/cart/add.js", {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            [CONFIG.giftPropertyKey]:
              CONFIG.giftPropertyValue
          }
        }
      ]
    });
  }

  async function removeGiftItems(giftItems) {
    /*
     * Satır sırası her silme işleminde değişebileceği için
     * hediye ürünleri tersten kaldırılır.
     */
    for (const { line } of [...giftItems].reverse()) {
      await cartRequest("/cart/change.js", {
        line,
        quantity: 0
      });
    }
  }

  function updateGiftBanner(cart) {
    const campaignStatus = getCampaignStatus();
    const qualifyingTotal = getQualifyingTotal(cart);
    const hasGift = getAutoGiftItems(cart).length > 0;

    document
      .querySelectorAll("[data-auto-gift-banner]")
      .forEach((banner) => {
        const status = banner.querySelector(
          "[data-auto-gift-status]"
        );

        const eligible =
          campaignStatus === "active" &&
          qualifyingTotal >= CONFIG.threshold;

        banner.classList.toggle(
          "is-campaign-active",
          campaignStatus === "active"
        );

        banner.classList.toggle(
          "is-eligible",
          eligible
        );

        banner.classList.toggle(
          "is-added",
          campaignStatus === "active" && hasGift
        );

        banner.classList.toggle(
          "is-ended",
          campaignStatus === "ended"
        );

        if (!status) return;

        if (campaignStatus === "not-started") {
          status.textContent =
            "Hediye kampanyası henüz başlamadı.";
          return;
        }

        if (campaignStatus === "ended") {
          status.textContent =
            "Hediye kampanyası sona erdi.";
          return;
        }

        if (hasGift) {
          status.textContent =
            "Hediyeniz sepetinize eklendi.";
        } else if (
          qualifyingTotal >= CONFIG.threshold
        ) {
          status.textContent =
            "Hediyeniz sepetinize ekleniyor.";
        } else {
          status.textContent =
            "Hediye için sepetinizde 15.000 TL tutara ulaşın.";
        }
      });
  }

  async function syncGift() {
    if (syncInProgress) return;

    syncInProgress = true;

    try {
      let cart = await getCart();
      let giftItems = getAutoGiftItems(cart);

      /*
       * Kampanya başlamadıysa veya sona erdiyse
       * sepetteki otomatik hediyeleri kaldır.
       */
      if (!isCampaignActive()) {
        if (giftItems.length > 0) {
          await removeGiftItems(giftItems);
          cart = await getCart();
        }

        updateGiftBanner(cart);
        return;
      }

      let qualifyingTotal = getQualifyingTotal(cart);

      /*
       * 15.000 TL ve üzerindeyse ve hediye yoksa ekle.
       */
      if (
        qualifyingTotal >= CONFIG.threshold &&
        giftItems.length === 0
      ) {
        await addGift();

        cart = await getCart();
        giftItems = getAutoGiftItems(cart);
        qualifyingTotal = getQualifyingTotal(cart);
      }

      /*
       * Tutar 15.000 TL altına düşerse
       * otomatik hediyelerin tamamını kaldır.
       */
      if (
        qualifyingTotal < CONFIG.threshold &&
        giftItems.length > 0
      ) {
        await removeGiftItems(giftItems);

        cart = await getCart();
        giftItems = getAutoGiftItems(cart);
      }

      /*
       * Birden fazla otomatik hediye oluşursa
       * yalnızca ilk hediye sepette kalır.
       */
      if (giftItems.length > 1) {
        await removeGiftItems(giftItems.slice(1));
        cart = await getCart();
      }

      updateGiftBanner(cart);
    } catch (error) {
      console.warn(
        "[İzgi Otomatik Hediye Sistemi]",
        error
      );
    } finally {
      syncInProgress = false;
    }
  }

  function scheduleSync(delay = 400) {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncGift();
    }, delay);
  }

  function isCartMutation(request) {
    try {
      const requestUrl =
        request instanceof Request
          ? request.url
          : request;

      const url = new URL(
        requestUrl,
        window.location.origin
      );

      return /^\/cart\/(add|change|update|clear)\.js$/.test(
        url.pathname
      );
    } catch (error) {
      return false;
    }
  }

  /*
   * Sepete ürün eklendiğinde, silindiğinde veya
   * ürün adedi değiştirildiğinde tekrar kontrol edilir.
   */
  window.fetch = async function (...args) {
    const response = await nativeFetch(...args);

    if (
      !syncInProgress &&
      isCartMutation(args[0])
    ) {
      scheduleSync(600);
    }

    return response;
  };

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      scheduleSync(800);
    }
  );
})();